import React from 'react';

export default function SparkleIcon({ size = 16, className = 'prompt-sparkle-icon' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M8 1.5L9.2 5.8L13.5 7L9.2 8.2L8 12.5L6.8 8.2L2.5 7L6.8 5.8L8 1.5Z"
        fill="currentColor"
      />
      <path
        d="M12.5 1L12.9 2.6L14.5 3L12.9 3.4L12.5 5L12.1 3.4L10.5 3L12.1 2.6L12.5 1Z"
        fill="currentColor"
        opacity="0.6"
      />
    </svg>
  );
}
